import { redirect } from "@tanstack/react-router";

import { LinkTo } from "@/@types/routing";
import { RouterContext } from "@/main";
import { Role } from "@/store";

type RequiredRolesParams = {
  allowed?: Role[];
  notAllowed?: Role[];
  fallback?: LinkTo;
};
export const requireRoles =
  ({ allowed, notAllowed, fallback = "/403" }: RequiredRolesParams) =>
  ({ context }: { context: RouterContext }) => {
    const store = context.store;
    const state = store.getState();
    const role = state.auth.role;

    if (!role) {
      throw redirect({ to: fallback });
    }

    const isAllowedViolated = allowed && !allowed.includes(role);
    const isNotAllowedViolated = notAllowed && notAllowed.includes(role);

    if (isAllowedViolated || isNotAllowedViolated) {
      throw redirect({ to: fallback });
    }
  };

type Ability = "admin:root" | "admin" | "user" | "shipping_company" | "exped" | "viewer" | "entrance";
type RequiredRolesParamsV2 = {
  allow?: Ability[];
  deny?: Ability[];
  fallback?: string;
};

const abilities = new Map<Ability, (ctx: RouterContext) => boolean>([
  [
    "admin:root",
    (ctx) => {
      const { role, isRoot } = ctx.store.getState().auth;
      return role === Role.Administrador && !!isRoot;
    }
  ],
  ["admin", (ctx) => ctx.store.getState().auth.role === Role.Administrador],
  ["shipping_company", (ctx) => ctx.store.getState().auth.role === Role.Transportadora],
  ["exped", (ctx) => ctx.store.getState().auth.role === Role.Expedicao],
  ["user", (ctx) => ctx.store.getState().auth.role === Role.Usuario],
  ["viewer", (ctx) => ctx.store.getState().auth.role === Role.Espectador],
  ["entrance", (ctx) => ctx.store.getState().auth.role === Role.Portaria]
]);

export const requireRolesV2 =
  ({ allow, deny, fallback = "/403" }: RequiredRolesParamsV2) =>
  ({ context }: { context: RouterContext }) => {
    const can = (ability: Ability) => abilities.get(ability)?.(context);

    if (allow && !allow.some(can)) {
      throw redirect({ to: fallback });
    }

    if (deny && deny.some(can)) {
      throw redirect({ to: fallback });
    }
  };
